import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetooutstationtempotraveller() {



  const cardData = {
"keyword": "Pune to Outstation Tempo Traveller",

"headingDescription":
  "Aaradhya Travels provides reliable Pune to Outstation Tempo Traveller service for family vacations, corporate tours, weddings, group trips, and long-distance travel across Maharashtra and nearby states. Our AC Tempo Travellers offer comfortable seating, experienced drivers, affordable pricing, and smooth travel for safe and enjoyable outstation journeys.",

"topPlaces": [
  {
    "title": "Mumbai",
    "description":
      "Mumbai is one of the most popular outstation destinations from Pune known for Marine Drive, Gateway of India, Juhu Beach, Bollywood attractions, shopping streets, nightlife, and business centers. Travelers often book Tempo Travellers for family tours, corporate trips, and weekend travel to Mumbai because of comfortable highway connectivity through the Mumbai Pune Expressway."
  },
  {
    "title": "Lonavala",
    "description":
      "Lonavala is a scenic hill station near Pune famous for waterfalls, green valleys, Tiger Point, Bhushi Dam, caves, and pleasant weather. It is one of the top weekend destinations for families and group tours traveling by Tempo Traveller during monsoon and winter seasons."
  },
  {
    "title": "Mahabaleshwar",
    "description":
      "Mahabaleshwar is a beautiful hill station known for strawberry farms, Venna Lake, mountain viewpoints, waterfalls, cool climate, and sightseeing attractions. Tempo Traveller trips from Pune to Mahabaleshwar are popular for family vacations, college groups, and corporate outings."
  },
  {
    "title": "Shirdi",
    "description":
      "Shirdi is a major pilgrimage destination visited by Sai Baba devotees from across India. Travelers prefer Tempo Traveller service for comfortable family pilgrimage tours, temple darshan trips, and group spiritual journeys from Pune."
  },
  {
    "title": "Nashik",
    "description":
      "Nashik is known for Trimbakeshwar Temple, vineyards, river ghats, religious tourism, and wine tourism. Pune to Nashik Tempo Traveller trips are ideal for pilgrimage groups, sightseeing tours, and corporate travel."
  },
  {
    "title": "Goa",
    "description":
      "Goa is one of the most preferred beach destinations from Pune famous for beaches, nightlife, water sports, churches, seafood, and resorts. Tempo Traveller bookings are common for friends groups, bachelor trips, family vacations, and holiday tours."
  },
  {
    "title": "Kolhapur",
    "description":
      "Kolhapur is famous for Mahalaxmi Temple, historical sites, traditional cuisine, shopping markets, and cultural heritage. Tempo Traveller tours from Pune to Kolhapur are preferred for religious travel and family road trips."
  },
  {
    "title": "Ratnagiri",
    "description":
      "Ratnagiri is a coastal destination known for beaches, mango farms, sea forts, Konkan scenery, and peaceful nature. Group travelers often choose Tempo Travellers for scenic Konkan road trips from Pune."
  },
  {
    "title": "Alibaug",
    "description":
      "Alibaug is a popular beach destination near Pune offering beaches, resorts, water sports, sea forts, and weekend relaxation. Tempo Traveller service is widely preferred for group beach vacations and family outings."
  },
  {
    "title": "Matheran",
    "description":
      "Matheran is a peaceful hill station known for toy train rides, viewpoints, forests, and pollution-free surroundings. Tempo Traveller journeys from Pune to Matheran are popular among families and nature lovers."
  },
  {
    "title": "Aurangabad",
    "description":
      "Aurangabad is famous for Ajanta Ellora Caves, Bibi Ka Maqbara, historical monuments, and Mughal heritage. Tempo Traveller trips are ideal for educational tours, family sightseeing, and heritage travel."
  },
  {
    "title": "Panchgani",
    "description":
      "Panchgani is a scenic hill station near Mahabaleshwar known for Table Land, viewpoints, strawberry farms, and cool climate. It is a popular outstation destination for relaxing family tours from Pune."
  },
  {
    "title": "Lavasa",
    "description":
      "Lavasa is a planned hill city near Pune known for lakeside views, adventure activities, colorful architecture, and peaceful surroundings. Tempo Traveller trips are ideal for corporate outings and group leisure tours."
  },
  {
    "title": "Tarkarli",
    "description":
      "Tarkarli is famous for clean beaches, scuba diving, snorkeling, sea tourism, and coastal beauty. Group travelers often prefer Tempo Travellers for long-distance beach road trips from Pune."
  },
  {
    "title": "Satara",
    "description":
      "Satara is known for Kaas Plateau, waterfalls, forts, and scenic mountain landscapes. Tempo Traveller journeys are popular during monsoon tourism and family sightseeing tours."
  },
  {
    "title": "Bhimashankar",
    "description":
      "Bhimashankar is a sacred Jyotirlinga temple destination surrounded by forests and hills. Tempo Traveller travel is commonly booked for pilgrimage groups and spiritual tours."
  },
  {
    "title": "Kaas Plateau",
    "description":
      "Kaas Plateau is a UNESCO-recognized flower valley famous for seasonal blooming flowers, nature photography, and monsoon tourism near Satara."
  },
  {
    "title": "Dapoli",
    "description":
      "Dapoli is a coastal Konkan destination known for beaches, dolphin sightseeing, seafood, forts, and peaceful tourism experiences."
  },
  {
    "title": "Igatpuri",
    "description":
      "Igatpuri is a hill station famous for Vipassana meditation center, mountain scenery, waterfalls, and monsoon landscapes attracting travelers from Pune."
  },
  {
    "title": "Kashid Beach",
    "description":
      "Kashid Beach is known for white sand beaches, water sports, beach resorts, and peaceful coastal tourism making it ideal for weekend Tempo Traveller trips."
  }
],



services: [
  {
    name: "Tempo Traveller Pune Rent",
    description: "Tempo Traveller Pune rent service provides comfortable and spacious transportation for family trips, corporate outings, airport transfers, group tours, and outstation travel requirements. Well-maintained vehicles ensure smooth highway journeys suitable for long-distance travel and local sightseeing. Professional chauffeurs provide safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Tempo Traveller rental reservations."
  },
  {
    name: "Pune Tempo Traveller Hire for Outstation",
    description: "Pune Tempo Traveller hire for outstation service offers dependable transportation for long-distance travel including Goa, Shirdi, Nashik, Mahabaleshwar, Kolhapur, Mumbai, and other tourist destinations. Spacious vehicles with comfortable seating and luggage space ensure pleasant travel experiences for families and groups. Professional drivers ensure safe highway driving and punctual pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow easy outstation traveller reservations."
  },
  {
    name: "Pune to Outstation Tempo Traveller",
    description: "Pune to outstation Tempo Traveller service provides reliable group transportation for vacations, business trips, pilgrimage tours, educational travel, and weekend getaways from Pune. Comfortable interiors and spacious seating ensure smooth long-distance travel for all passengers. Professional chauffeurs provide safe driving and dependable transportation services across all major routes. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient outstation traveller bookings."
  },
  {
    name: "Pune to Goa Tempo Traveller",
    description: "Pune to Goa Tempo Traveller service offers premium transportation for beach vacations, family holidays, bachelor trips, corporate outings, and tourist travel from Pune. Spacious vehicles ensure comfortable overnight and long-distance journeys with ample luggage capacity for passengers. Professional drivers ensure safe highway driving and reliable transportation services throughout the Goa route. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Goa traveller reservations."
  },
  {
    name: "Pune to Kolhapur Tempo Traveller Rent",
    description: "Pune to Kolhapur Tempo Traveller rent service provides comfortable transportation for pilgrimage tours, family travel, business trips, and sightseeing journeys from Pune to Kolhapur. Spacious vehicles ensure smooth highway travel suitable for groups and tourists. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Kolhapur traveller reservations."
  },
  {
    name: "Pune Tempo Traveller Hire for Outstation",
    description: "Pune Tempo Traveller hire for outstation service provides economical and dependable travel solutions for group vacations, family tours, corporate outings, and long-distance journeys from Pune. Comfortable vehicles ensure smooth highway travel with spacious seating and luggage space suitable for all passenger groups. Professional chauffeurs ensure safe driving and timely pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow easy traveller hire reservations."
  },
  {
    name: "Pune to Nashik Tempo Traveller Rent",
    description: "Pune to Nashik Tempo Traveller rent service offers reliable transportation for pilgrimage tours, wine tourism, business trips, family vacations, and sightseeing travel from Pune. Comfortable vehicles ensure smooth highway journeys suitable for local and outstation group travel. Professional drivers provide safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Nashik traveller reservations."
  },
  {
    name: "Pune to Mumbai Tempo Traveller Rent",
    description: "Pune to Mumbai Tempo Traveller rent service provides comfortable transportation for corporate travel, airport transfers, family tours, wedding travel, and business meetings between Pune and Mumbai. Spacious vehicles ensure smooth expressway journeys suitable for group passengers and long-distance travel. Professional chauffeurs provide safe driving and timely pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Mumbai traveller reservations."
  },
  {
    name: "Pune to Pandharpur Tempo Traveller Fare",
    description: "Pune to Pandharpur Tempo Traveller fare service offers affordable and dependable transportation for devotees, pilgrimage groups, family darshan tours, and spiritual travel to Pandharpur from Pune. Comfortable vehicles ensure smooth highway journeys suitable for senior citizens and group travel. Professional drivers provide safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Pandharpur traveller reservations."
  },
  {
    name: "Pune Mumbai Airport Drop Tempo Traveller on Rent",
    description: "Pune Mumbai Airport drop Tempo Traveller on rent service provides direct airport transportation for families, tourists, corporate teams, and group travelers heading to Mumbai Airport from Pune. Spacious vehicles ensure comfortable luggage handling and smooth expressway travel suitable for airport journeys. Professional chauffeurs ensure timely pickups and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and commercial locations across Pune. Flexible booking options allow convenient airport traveller reservations."
  },
  {
    name: "Tempo Traveller on Rent for Wedding in Pune",
    description: "Tempo Traveller on rent for wedding in Pune service offers spacious and luxurious transportation for wedding guests, family members, bridal parties, and event travel requirements. Comfortable seating and premium interiors ensure smooth travel experiences suitable for wedding ceremonies and functions. Professional chauffeurs provide punctual pickup and reliable transportation services throughout the event schedule. Pickup services are available from homes, hotels, banquet halls, railway stations, and airport terminals across Pune. Flexible booking options allow convenient wedding traveller reservations."
  },
  {
    name: "17 Seater Tempo Traveller for Outstation in Pune",
    description: "17 seater Tempo Traveller for outstation in Pune service provides comfortable transportation for large family groups, corporate teams, tourist travel, and long-distance outstation journeys. Spacious interiors and pushback seating ensure pleasant highway travel experiences for all passengers. Professional drivers provide safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient 17 seater traveller reservations."
  },
  {
    name: "Luxury Tempo Traveller on Rent in Pune",
    description: "Luxury Tempo Traveller on rent in Pune service offers premium group transportation with comfortable pushback seating, air conditioning, stylish interiors, and spacious cabins for luxury travel experiences. Vehicles are suitable for weddings, corporate events, VIP travel, family vacations, and outstation journeys. Professional chauffeurs ensure smooth highway travel and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient luxury traveller reservations."
  },
  {
    name: "Outstation Tempo Traveller",
    description: "Outstation Tempo Traveller service provides reliable transportation for long-distance travel, hill station tours, pilgrimage journeys, family vacations, and corporate group outings from Pune. Spacious vehicles ensure comfortable seating and smooth highway journeys suitable for all passenger groups. Professional drivers ensure safe driving and punctual pickup services across all major tourist routes. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient outstation traveller reservations."
  }
],

tableData: [
  ["Tempo Traveller Pune Rent", "Pune Tempo Traveller Hire for Outstation"],
  ["Pune to Outstation Tempo Traveller", "Pune to Goa Tempo Traveller"],
  ["Pune to Kolhapur Tempo Traveller Rent", "Pune Tempo Traveller Hire for Outstation"],
  ["Pune to Nashik Tempo Traveller Rent", "Pune to Mumbai Tempo Traveller Rent"],
  ["Pune to Pandharpur Tempo Traveller Fare", "Pune Mumbai Airport Drop Tempo Traveller on Rent"],
  ["Tempo Traveller on Rent for Wedding in Pune", "17 Seater Tempo Traveller for Outstation in Pune"],
  ["Luxury Tempo Traveller on Rent in Pune", "Outstation Tempo Traveller"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Outstation Tempo Traveller Service",
        WhyChoosedescription: "Aaradhya Travels provides reliable Pune to outstation Tempo Traveller service with comfortable vehicles, professional drivers, and well-planned travel arrangements for long-distance journeys and group tours."
      },
      {
        WhyChooseheading: "Affordable Outstation Tempo Traveller Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable Pune to outstation Tempo Traveller rental packages with transparent pricing, flexible travel plans, and complete booking support without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Outstation Tempo Traveller Booking",
        WhyChoosedescription: "Our Pune to outstation Tempo Traveller service is available 24 hours for family vacations, corporate tours, pilgrimage trips, wedding travel, weekend getaways, and holiday journeys."
      },
      {
        WhyChooseheading: "Comfortable & Spacious AC Tempo Travellers",
        WhyChoosedescription: "All Tempo Travellers provided by Aaradhya Travels are fully air-conditioned, spacious, clean, and regularly maintained for comfortable long-distance travel experiences."
      },
      {
        WhyChooseheading: "Flexible One Day & Multi-Day Tour Plans",
        WhyChoosedescription: "Aaradhya Travels offers customized one-day trips, weekend tours, multi-day outstation travel packages, and flexible travel itineraries according to customer requirements."
      },
      {
        WhyChooseheading: "13, 17 & 20 Seater Tempo Traveller Options",
        WhyChoosedescription: "Customers can choose from multiple Tempo Traveller seating options including 13 seater, 17 seater, and 20 seater vehicles suitable for family tours, tourist groups, and corporate travel."
      },
      {
        WhyChooseheading: "Pickup Available Across Pune Locations",
        WhyChoosedescription: "Aaradhya Travels provides doorstep pickup from Pune Airport, railway stations, hotels, homes, and major Pune locations including Baner, Wakad, Kharadi, Pimpri, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Highway Travel",
        WhyChoosedescription: "Our experienced drivers are skilled in handling long-distance highway routes and ensure safe driving, smooth travel, and timely arrival for every outstation journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune to outstation Tempo Traveller service?", answer: "Pune to outstation Tempo Traveller service provides comfortable group transportation for long-distance travel, family tours, corporate trips, and holiday journeys." },
    { question: "Is outstation Tempo Traveller booking available 24 hours?", answer: "Yes, Aaradhya Travels provides 24/7 outstation Tempo Traveller booking service from Pune." },
    { question: "Which Tempo Traveller seating options are available?", answer: "Aaradhya Travels offers 13 seater, 17 seater, and 20 seater Tempo Travellers for different group travel requirements." },
    { question: "Can I book Tempo Traveller for multi-day outstation trips?", answer: "Yes, customers can book Tempo Travellers for one-day, weekend, and multi-day outstation tours." },
    { question: "Do you provide customized outstation travel packages?", answer: "Yes, Aaradhya Travels provides customized outstation travel packages according to customer requirements." },
    { question: "Are all Tempo Travellers air-conditioned?", answer: "Yes, all Tempo Travellers are fully air-conditioned and maintained for comfortable travel." },
    { question: "Can I book outstation Tempo Traveller online?", answer: "Yes, customers can easily book outstation Tempo Traveller service online or through phone booking." },
    { question: "Do you provide Tempo Travellers for family and group tours?", answer: "Yes, Aaradhya Travels provides spacious Tempo Travellers suitable for family tours and group travel." },
    { question: "Are Pune to outstation Tempo Traveller charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for outstation Tempo Traveller service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and peak travel seasons." }
  ];

  const testimonials = [
  {
    id: 1,
    name: "Mr. Prasad Kulkarni",
    feedback:
      "Our outstation journey from Pune with Aaradhya Travels in a Tempo Traveller was very comfortable and well managed. The ride remained smooth even on long routes, and the group travel experience was hassle-free.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Patil",
    feedback:
      "Aaradhya Travels arranged an outstation Tempo Traveller from Pune for our family trip, and everything went perfectly. The vehicle was spacious, clean, and made the long journey enjoyable for everyone.",
    rating: 5
  }
];








  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Outstation Tempo Traveller",
  "image": "https://www.aaradhyatravels99.com/assets/images/pune-to-outstation-tempo-traveller.jpg",
  "description": "Hire Pune to Outstation Tempo Traveller with Aaradhya Travels for family trips, corporate tours, weddings, airport transfers, picnics, and group travel. Luxury 17 seater tempo traveller available for Goa, Mumbai, Nashik, Kolhapur, Pandharpur and more.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4126"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/pune-to-outstation-tempo-traveller"
  }
};





  return (
    <div>
<Helmet>
  <title>
    Pune to Outstation Tempo Traveller | Luxury 17 Seater Hire | +91 9529697070
  </title>

  <meta
    name="description"
    content="Book Pune to Outstation Tempo Traveller with Aaradhya Travels. Affordable luxury 17 seater traveller available for Goa, Mumbai, Nashik, Kolhapur, Pandharpur, airport transfers, weddings, corporate tours, picnics and family trips."
  />

  <meta
    name="keywords"
    content="Tempo traveller pune rent, Pune tempo traveller hire for outstation, Pune to outstation tempo traveller, Pune to goa Tempo Traveller, pune to kolhapur tempo traveller rent, pune tempo traveller hire for outstation, pune to nashik tempo traveller rent, pune to mumbai tempo traveller rent, pune to pandharpur tempo traveller fare, Pune Mumbai Airport Drop Tempo Traveller on Rent, Tempo Traveller On Rent for Wedding in Pune, 17 Seater Tempo Traveller for Outstation in Pune, Luxury tempo traveller on rent in pune, Outstation tempo traveller for picnic"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/3.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetooutstationtempotraveller;